import { useEffect, useMemo, useState } from "react";
import { deriveToofiResumeTarget } from "@/lib/toofi-resume";
import { readStudentToofiState, STUDENT_TOOFI_STATE_EVENT } from "@/lib/student-toofi-threads";
import { readToofiArtifactIndex } from "@/lib/toofi-artifact-index";
import { TOOFI_ARTIFACT_STORAGE_EVENT } from "@/lib/toofi-artifact-types";

const readResumeTarget = () => deriveToofiResumeTarget(readStudentToofiState(), readToofiArtifactIndex());

export function useToofiResume() {
  const [resumeTarget, setResumeTarget] = useState(() => readResumeTarget());

  useEffect(() => {
    const refresh = () => setResumeTarget(readResumeTarget());
    window.addEventListener(STUDENT_TOOFI_STATE_EVENT, refresh);
    window.addEventListener(TOOFI_ARTIFACT_STORAGE_EVENT, refresh);
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener(STUDENT_TOOFI_STATE_EVENT, refresh);
      window.removeEventListener(TOOFI_ARTIFACT_STORAGE_EVENT, refresh);
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);

  return useMemo(
    () => ({
      resumeTarget,
      hasResumeTarget: Boolean(resumeTarget),
    }),
    [resumeTarget],
  );
}
